/* Per-card product-image Swiper for collection/grid cards.
   Uses the theme's globally-loaded Swiper. Inits lazily via IntersectionObserver
   so a grid of 50 cards doesn't build 50 Swipers up front — each initialises
   just before it scrolls into view. Deferred slides (all images past the first,
   parked in a <template>) are injected right before init. */
(function () {
  if (typeof window === 'undefined') return;

  function hydrate(container) {
    var tpl = container.querySelector('template[data-deferred-slides]');
    if (tpl) {
      var wrapper = container.querySelector('.swiper-wrapper');
      if (wrapper) wrapper.insertAdjacentHTML('beforeend', tpl.innerHTML);
      tpl.remove();
    }
  }

  function initOne(container) {
    if (container.__cardSwiperInit) return;
    // Swiper is loaded with defer; if it isn't ready yet, retry shortly rather
    // than marking this card done (which would leave it un-initialised forever).
    if (typeof window.Swiper === 'undefined') {
      setTimeout(function () { initOne(container); }, 200);
      return;
    }
    container.__cardSwiperInit = true;

    hydrate(container);

    var slides = container.querySelectorAll('.swiper-slide');
    var dotsEl = container.querySelector('[data-card-img-dots]');

    // Single image: nothing to swipe — skip Swiper entirely.
    if (slides.length <= 1) {
      if (dotsEl) dotsEl.style.display = 'none';
      return;
    }

    if (dotsEl) {
      dotsEl.innerHTML = Array.prototype.map
        .call(slides, function (_, i) {
          return '<span class="card-img-swiper__dot' + (i === 0 ? ' is-active' : '') + '"></span>';
        })
        .join('');
    }

    new window.Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      grabCursor: true,
      threshold: 6,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      on: {
        slideChange: function () {
          if (!dotsEl) return;
          var dots = dotsEl.querySelectorAll('.card-img-swiper__dot');
          for (var i = 0; i < dots.length; i++) {
            dots[i].classList.toggle('is-active', i === this.activeIndex);
          }
        },
      },
    });

    if (dotsEl) {
      dotsEl.addEventListener('click', function (e) {
        var dot = e.target.closest('.card-img-swiper__dot');
        if (!dot || !container.swiper) return;
        var idx = Array.prototype.indexOf.call(dotsEl.children, dot);
        if (idx >= 0) container.swiper.slideTo(idx);
      });
    }
  }

  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) {
                initOne(en.target);
                io.unobserve(en.target);
              }
            });
          },
          { rootMargin: '50px 0px' }
        )
      : null;

  function scan(root) {
    (root || document).querySelectorAll('[data-card-img-swiper]').forEach(function (c) {
      if (c.__cardSwiperSeen) return;
      c.__cardSwiperSeen = true;
      if (io) io.observe(c);
      else initOne(c); // no IO support: init immediately
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });

  // Collection grids re-render on filter/sort/infinite-scroll — pick up new cards.
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1) scan(n);
      }
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
